<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <p class="hdg02 mb0">カスタマイズの初期化</p>
        </div>
        <div class="popup-content">
          <p class="txt">カスタマイズの設定を初期化します。以下デフォルトに戻しますがよろしいですか？</p>
          <ul>
            <li>表示/非表示</li>
            <li>位置</li>
            <li>表示件数</li>
          </ul>
          <p class="txt mt10">※マイリンクは初期化対象外</p>
          <div class="button submit"
            @click="submit"
          >
            <span class="btn">初期化</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {

    const group1 = reactive({
    })
    const close = () => {
      context.emit('closeCustomizationInitializeConfirm')
    }
    const submit = () => {
      // 保存
      context.emit('closeCustomizationInitializeConfirm')
    }

    return {
      group1,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    ul {
      margin-left: 20px;
      color: $color-content;
      margin-bottom: 12px;
    }
    .button.submit {
      width: 230px;
      margin: 0 auto;
    }
  }
}
</style>
